import api from './api';

export const fetchCustomerFicha = (customerId) =>
  api.get(`/customers/${customerId}/ficha`).then((r) => r.data);

export const resendFichaMessage = (customerId, payload) =>
  api.post(`/customers/${customerId}/ficha/resend`, payload).then((r) => r.data);

export const changeCustomerInstance = (customerId, instanceName) =>
  api.patch(`/customers/${customerId}/instance`, { instance_name: instanceName }).then((r) => r.data);

export const fetchInstances = () =>
  api.get('/instances').then((r) => r.data);
